import React, { useRef, useState } from "react";
import { useFormik } from "formik";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import * as Yup from "yup";
// import { adminMainUrl } from '../../Config';
import Offcanvas from "react-bootstrap/Offcanvas";
import { adminMainUrl } from "../../../../../Config";

const AddParent = ({ show, handleClose, onSuccess, refresh }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const closeButtonRef = useRef(null);
  const validationSchema = Yup.object({
    name: Yup.string().required("Parent is required."),
    ledger_nature: Yup.string().required("Ledger Nature is required."),
    balance_sheet_type: Yup.string().required(
      "Balance Sheet Type is required."
    ),
  });

  // Initialize Formik
  const formik = useFormik({
    initialValues: {
      name: "", // Initial value for the RequiredService type
      ledger_nature: "",
      balance_sheet_type: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
    //   console.log("data", values);
      setIsSubmitting(true);
      try {
        const response = await fetch(
          `${adminMainUrl}/api/account/parent-group`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "auth-token": Cookies.get("token"), // Assuming token is stored in cookies
              user_id: Cookies.get("flexichain_user_id"),
            },
            body: JSON.stringify(values),
          }
        );
        const data = await response.json();
        if (response.ok) {
          // closeButtonRef.current.click();
          if (onSuccess) onSuccess();
          toast.success(data?.msg);
          handleClose();
          refresh();
          formik.resetForm();
        } else {
          toast.error(data?.msg);
          console.error("Error creating RequiredService Type:", data.message);
        }
      } catch (error) {
        console.error("Network error:", error);
      } finally {
        setIsSubmitting(false); // Stop the spinner
      }
    },
  });
  return (
    <Offcanvas
      className="custom-offcanvas"
      show={show}
      onHide={handleClose}
      placement="end"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>Add Parent</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-3">
            <label htmlFor="name" className="form-label">
              Parent <span style={{ color: "red" }}>*</span>
            </label>
            <input
              type="text"
              className="form-control form-control-sm"
              id="name"
              name="name"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.name}
            />
            {formik.touched.name && formik.errors.name ? (
              <div className="error">{formik.errors.name}</div>
            ) : null}
          </div>

          <div className="mb-3">
            <label htmlFor="name" className="form-label">
              Ledger Nature <span style={{ color: "red" }}>*</span>
            </label>
            <select
              name="ledger_nature"
              className="form-select bg-light padding-pt-9"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="">Select Ledger Nature</option>
              <option value="Debit">Debit</option>
              <option value="Credit">Credit</option>
            </select>
            {formik.touched.ledger_nature && formik.errors.ledger_nature ? (
              <div className="error">{formik.errors.ledger_nature}</div>
            ) : null}
          </div>

          <div className="mb-3">
            <label htmlFor="name" className="form-label">
              Balance Sheet Type <span style={{ color: "red" }}>*</span>
            </label>
            <select
              name="balance_sheet_type"
              className="form-select bg-light padding-pt-9"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
            >
              <option value="">Select Balance Sheet Type</option>
              <option value="Balance Sheet">Balance Sheet</option>
              <option value="P&L">P&L</option>
            </select>
            {formik.touched.balance_sheet_type &&
            formik.errors.balance_sheet_type ? (
              <div className="error">{formik.errors.balance_sheet_type}</div>
            ) : null}
          </div>

          <div className="d-flex justify-content-end">
            <button
              className="btn btn-primary text-xs"
              type="submit"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <i className="fa fa-spinner fa-spin" />
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddParent;
